/*!
 *
 *  expand-menu.js
 *
 */

var $elems;

var menu = function( elem ){
	this.$elem = $(elem);
	this.init();
};

menu.prototype = {
	init: function(){
		//this.cl = this.$elem.attr('class').replace(/(.+)(\-.+)/, '$1');
		this.cl = this.$elem.attr('class');
		this.$link = this.$elem.children('.' + this.cl + '_Link');
		this.setEvent();
	},
	setEvent: function(){
		var self = this;

		this.$link.on('tap', function(e){
			self.toggle(e);
		});

		this.$link.on('keydown', function(e){
			if( e.keyCode === 13 ) {
				self.toggle(e);
			};
		});

		this.$elem.on('close', function(){
			$(this).removeClass(self.cl + '-expanded');
		});
	},
	toggle: function(e){
		e.preventDefault();
		$elems.not( this.$elem ).trigger('close');
		this.$elem.toggleClass(this.cl + '-expanded');
	}
};

module.exports = function( elems ){
	$elems = $(elems);
	$elems.each(function(){
		new menu(this);
	});
	$(document).on('tap', function(e){
		if( !$(e.target).closest( elems ).length ) {
			$elems.trigger('close');
		};
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/expand-menu.js
// module id = 21
// module chunks = 0